import React, { useContext, useState } from "react";
import "./Security_Settings.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import Verify_Profile_Modal from "../../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import Change_Trading_Password_Modal from "../../../common_components/common_modal/change_trading_password_modal/Change_Trading_Password_Modal";
import { Context } from "../../../../utils/context";

const Security_Settings = () => {
  const [showModal, setShowModal] = useState(false);

  const { IMG_URL, userdata } = useContext(Context);

  return (
    <section className="Security_Settings">
      <div className="info_outer_div">
        <div className="top_head_section">
          <div className="left_side">
            <p className="section_title">Authorization</p>
          </div>

          <div className="right_side">
            <div
              className="icon_holder"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <FontAwesomeIcon icon={faPencil} className="edit_icon" />
            </div>
          </div>
        </div>

        <div className="info_inner_div">
          <div className="row">
            <div className="col-md-6 custom_col">
              <div className="label_holder">
                <p className="label_text">Login:</p>
                <p className="label_text">{userdata?.email}</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="label_holder">
                <p className="label_text">Password:</p>
                <p className="label_text">{userdata?.show_password}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Change_Trading_Password_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Security_Settings;
